var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUavNeutral = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 105,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#uav-neutral_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 45,
  r: 24,
  stroke: "#000",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 45,
  r: 20.5,
  fill: "#F7F7F9",
  stroke: "#F7F7F9",
  strokeWidth: 5
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#uav-neutral_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.392 39.67a3.446 3.446 0 0 1-4.261-5.357 3.445 3.445 0 0 1 5.357 4.262l1.322 1.322a5.684 5.684 0 0 0 8.038 0l1.726-1.726a3.446 3.446 0 0 1 5.417-4.162 3.445 3.445 0 0 1-4.5 5.194l-1.425 1.425a5.684 5.684 0 0 0 0 8.038l1.603 1.602a3.446 3.446 0 0 1 4.261 5.358 3.445 3.445 0 0 1-5.357-4.262l-1.36-1.359a5.684 5.684 0 0 0-8.037 0l-1.777 1.777a3.446 3.446 0 1 1-.933-1.016l1.492-1.491a5.684 5.684 0 0 0 0-8.038l-1.566-1.566Zm-.759-.758a2.412 2.412 0 1 1 1.096-1.096l-.527-.527a1.722 1.722 0 1 0-1.096 1.096l.527.527Zm.09 12.598a2.412 2.412 0 1 0 .912 1.036l-.535.535a1.722 1.722 0 1 1-.883-1.066l.505-.505Zm13.608.613a2.412 2.412 0 1 0 1.096-1.096l.528.527a1.722 1.722 0 1 1-1.096 1.096l-.528-.527Zm.902-13.662a2.412 2.412 0 1 0-.89-1.058l.541-.542a1.721 1.721 0 0 1 2.89-1.634 1.722 1.722 0 0 1-2.04 2.732l-.501.502Z",
  fill: "#9A9DB5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "uav-neutral_svg__a",
  x: 11,
  y: 20,
  width: 58,
  height: 58,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_3714_347520"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3714_347520",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "uav-neutral_svg__b",
  x: 26,
  y: 33,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_3714_347520"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3714_347520",
  result: "shape"
})))));

export { SvgUavNeutral as ReactComponent };
export default __webpack_public_path__ + "42dee80896e59286043b938b5d777ca1.svg";